/* Copyright (C) nexleader - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written for nexleader <myipsat.com>, 2016-2026
 */

import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { Archetype, ARCHETYPE_DISPLAY_NAMES } from '../../../engine/archetype-engine';

interface RichInteraction {
  title: string;
  dynamic: string;
  best_practices: string;
  example: string;
  for_user: string;
}

interface InteractionRow {
  archetypeKey: string;
  archetypeName: string;
  // Legacy single-line description from the content library (fallback).
  description?: string;
  // Rich AI-personalized card (preferred when present).
  rich?: RichInteraction;
}

/**
 * Card 5: How [Primary] Interfaces with the Other Five.
 *
 * Prefers the rich AI-personalized cards from `aiInteractions` (Prompt 7)
 * when present; falls back to the single seed line from
 * `primary_archetype_library.archetype_interactions` for legacy reports
 * that pre-date the prompt-7 addition.
 */
@Component({
  selector: 'app-archetype-interfaces-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './archetype-interfaces-modal.component.html',
})
export class ArchetypeInterfacesModalComponent {
  @Input() primaryContent: any;
  @Input() primaryArchetypeName?: string;
  @Input() userFirstName?: string;
  @Input() aiInteractions: Record<string, RichInteraction> | null = null;

  constructor(public bsModalRef: BsModalRef) {}

  get rows(): InteractionRow[] {
    const staticInteractions = this.primaryContent?.archetype_interactions || {};
    const slugs = Object.keys(staticInteractions);
    return slugs
      .map(slug => {
        const rich = this.aiInteractions ? this.aiInteractions[slug] : null;
        const description = staticInteractions[slug] as string;
        if (!rich && !description) return null;
        return {
          archetypeKey: slug,
          archetypeName: ARCHETYPE_DISPLAY_NAMES[slug as Archetype] || slug,
          description: description || undefined,
          rich: rich || undefined,
        } as InteractionRow;
      })
      .filter((r): r is InteractionRow => r !== null);
  }

  get hasRichRows(): boolean {
    return this.rows.some(r => !!r.rich);
  }

  get headerTitle(): string {
    return `How ${this.primaryArchetypeName || 'Your Archetype'} Interfaces with the Other Five`;
  }

  close(): void {
    this.bsModalRef.hide();
  }
}
